/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SandboxRouteImport } from './routes/sandbox'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SecureSplatRouteImport } from './routes/secure/$'
import { Route as ImplicitCallbackRouteImport } from './routes/implicit/callback'
import { Route as AuthUnauthorizedRouteImport } from './routes/_auth/unauthorized'
import { Route as AuthUserLookupRouteRouteImport } from './routes/_auth/user-lookup/route'
import { Route as AuthQaToolsRouteRouteImport } from './routes/_auth/qa-tools/route'
import { Route as AuthPartnerRouteRouteImport } from './routes/_auth/partner/route'
import { Route as AuthOverridesRouteRouteImport } from './routes/_auth/overrides/route'
import { Route as AuthMilestonesRouteRouteImport } from './routes/_auth/milestones/route'
import { Route as AuthMediaValidationRouteRouteImport } from './routes/_auth/media-validation/route'
import { Route as AuthLoggerRouteRouteImport } from './routes/_auth/logger/route'
import { Route as AuthIpOverrideRouteRouteImport } from './routes/_auth/ip-override/route'
import { Route as AuthEsniRouteRouteImport } from './routes/_auth/esni/route'
import { Route as AuthBtcToolsRouteRouteImport } from './routes/_auth/btc-tools/route'
import { Route as AuthAuditRouteRouteImport } from './routes/_auth/audit/route'
import { Route as AuthUserLookupIndexRouteImport } from './routes/_auth/user-lookup/index'
import { Route as AuthQaToolsIndexRouteImport } from './routes/_auth/qa-tools/index'
import { Route as AuthPartnerIndexRouteImport } from './routes/_auth/partner/index'
import { Route as AuthOverridesIndexRouteImport } from './routes/_auth/overrides/index'
import { Route as AuthMilestonesIndexRouteImport } from './routes/_auth/milestones/index'
import { Route as AuthMediaValidationIndexRouteImport } from './routes/_auth/media-validation/index'
import { Route as AuthLoggerIndexRouteImport } from './routes/_auth/logger/index'
import { Route as AuthIpOverrideIndexRouteImport } from './routes/_auth/ip-override/index'
import { Route as AuthEsniIndexRouteImport } from './routes/_auth/esni/index'
import { Route as AuthBtcToolsIndexRouteImport } from './routes/_auth/btc-tools/index'
import { Route as AuthAuditIndexRouteImport } from './routes/_auth/audit/index'
import { Route as AuthQaToolsDevConfigsRouteImport } from './routes/_auth/qa-tools/dev-configs'
import { Route as AuthPartnerTargetsRouteImport } from './routes/_auth/partner/targets'
import { Route as AuthPartnerMappingRouteImport } from './routes/_auth/partner/mapping'
import { Route as AuthOverridesSessionRouteImport } from './routes/_auth/overrides/session'
import { Route as AuthOverridesPlaybackRouteImport } from './routes/_auth/overrides/playback'
import { Route as AuthMilestonesGamePkRouteImport } from './routes/_auth/milestones/$gamePk'
import { Route as AuthMediaValidationPlayerValidatorRouteImport } from './routes/_auth/media-validation/player-validator'
import { Route as AuthMediaValidationLitmusRouteImport } from './routes/_auth/media-validation/litmus'
import { Route as AuthLoggerGamePkRouteImport } from './routes/_auth/logger/$gamePk'
import { Route as AuthIpOverrideUserLookupRouteImport } from './routes/_auth/ip-override/user-lookup'
import { Route as AuthIpOverrideOverridesRouteImport } from './routes/_auth/ip-override/overrides'
import { Route as AuthEsniPoliciesRouteImport } from './routes/_auth/esni/policies'
import { Route as AuthEsniMediaRouteImport } from './routes/_auth/esni/media'
import { Route as AuthEsniAudiencesRouteImport } from './routes/_auth/esni/audiences'
import { Route as AuthBtcToolsTeamZixiSourcesRouteImport } from './routes/_auth/btc-tools/team-zixi-sources'
import { Route as AuthBtcToolsCdnStatusRouteImport } from './routes/_auth/btc-tools/cdn-status'
import { Route as AuthBtcToolsBroadcastSourceOverridesRouteImport } from './routes/_auth/btc-tools/broadcast-source-overrides'
import { Route as AuthAuditScheduleRouteImport } from './routes/_auth/audit/schedule'
import { Route as AuthAuditAuditsRouteImport } from './routes/_auth/audit/audits'
import { Route as AuthBtcToolsScheduleRouteRouteImport } from './routes/_auth/btc-tools/schedule/route'
import { Route as AuthBtcToolsConfigsRouteRouteImport } from './routes/_auth/btc-tools/configs/route'
import { Route as AuthEsniRulesIndexRouteImport } from './routes/_auth/esni/rules/index'
import { Route as AuthBtcToolsScheduleIndexRouteImport } from './routes/_auth/btc-tools/schedule/index'
import { Route as AuthEsniRulesProcessRouteImport } from './routes/_auth/esni/rules/process'
import { Route as AuthEsniRulesCreateRouteImport } from './routes/_auth/esni/rules/create'
import { Route as AuthEsniRulesRuleIdRouteImport } from './routes/_auth/esni/rules/$ruleId'
import { Route as AuthBtcToolsConfigsSkyviewRouteImport } from './routes/_auth/btc-tools/configs/skyview'
import { Route as AuthBtcToolsConfigsPipelineInputRouteImport } from './routes/_auth/btc-tools/configs/pipeline-input'
import { Route as AuthBtcToolsConfigsPipelineRouteImport } from './routes/_auth/btc-tools/configs/pipeline'
import { Route as AuthBtcToolsConfigsMulticastMappingsRouteImport } from './routes/_auth/btc-tools/configs/multicast-mappings'
import { Route as AuthBtcToolsScheduleGamePkRouteRouteImport } from './routes/_auth/btc-tools/schedule/$gamePk/route'
import { Route as AuthBtcToolsScheduleGamePkContentRouteImport } from './routes/_auth/btc-tools/schedule/$gamePk/content'
import { Route as AuthBtcToolsScheduleGamePkPipelinesIndexRouteImport } from './routes/_auth/btc-tools/schedule/$gamePk/pipelines/index'
import { Route as AuthBtcToolsScheduleGamePkBroadcastsIndexRouteImport } from './routes/_auth/btc-tools/schedule/$gamePk/broadcasts/index'
import { Route as AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRouteImport } from './routes/_auth/btc-tools/schedule/$gamePk/broadcast-acquisitions/index'
import { Route as AuthBtcToolsScheduleGamePkPipelinesPipelineIdRouteImport } from './routes/_auth/btc-tools/schedule/$gamePk/pipelines/$pipelineId'
import { Route as AuthBtcToolsScheduleGamePkBroadcastsMediaIdRouteImport } from './routes/_auth/btc-tools/schedule/$gamePk/broadcasts/$mediaId'

const SandboxRoute = SandboxRouteImport.update({
  id: '/sandbox',
  path: '/sandbox',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SecureSplatRoute = SecureSplatRouteImport.update({
  id: '/secure/$',
  path: '/secure/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ImplicitCallbackRoute = ImplicitCallbackRouteImport.update({
  id: '/implicit/callback',
  path: '/implicit/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthUnauthorizedRoute = AuthUnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUserLookupRouteRoute = AuthUserLookupRouteRouteImport.update({
  id: '/user-lookup',
  path: '/user-lookup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQaToolsRouteRoute = AuthQaToolsRouteRouteImport.update({
  id: '/qa-tools',
  path: '/qa-tools',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPartnerRouteRoute = AuthPartnerRouteRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOverridesRouteRoute = AuthOverridesRouteRouteImport.update({
  id: '/overrides',
  path: '/overrides',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMilestonesRouteRoute = AuthMilestonesRouteRouteImport.update({
  id: '/milestones',
  path: '/milestones',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMediaValidationRouteRoute =
  AuthMediaValidationRouteRouteImport.update({
    id: '/media-validation',
    path: '/media-validation',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLoggerRouteRoute = AuthLoggerRouteRouteImport.update({
  id: '/logger',
  path: '/logger',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIpOverrideRouteRoute = AuthIpOverrideRouteRouteImport.update({
  id: '/ip-override',
  path: '/ip-override',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEsniRouteRoute = AuthEsniRouteRouteImport.update({
  id: '/esni',
  path: '/esni',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBtcToolsRouteRoute = AuthBtcToolsRouteRouteImport.update({
  id: '/btc-tools',
  path: '/btc-tools',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditRouteRoute = AuthAuditRouteRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUserLookupIndexRoute = AuthUserLookupIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthUserLookupRouteRoute,
} as any)
const AuthQaToolsIndexRoute = AuthQaToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthQaToolsRouteRoute,
} as any)
const AuthPartnerIndexRoute = AuthPartnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPartnerRouteRoute,
} as any)
const AuthOverridesIndexRoute = AuthOverridesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOverridesRouteRoute,
} as any)
const AuthMilestonesIndexRoute = AuthMilestonesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMilestonesRouteRoute,
} as any)
const AuthMediaValidationIndexRoute =
  AuthMediaValidationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthMediaValidationRouteRoute,
  } as any)
const AuthLoggerIndexRoute = AuthLoggerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLoggerRouteRoute,
} as any)
const AuthIpOverrideIndexRoute = AuthIpOverrideIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthIpOverrideRouteRoute,
} as any)
const AuthEsniIndexRoute = AuthEsniIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthEsniRouteRoute,
} as any)
const AuthBtcToolsIndexRoute = AuthBtcToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthBtcToolsRouteRoute,
} as any)
const AuthAuditIndexRoute = AuthAuditIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAuditRouteRoute,
} as any)
const AuthQaToolsDevConfigsRoute = AuthQaToolsDevConfigsRouteImport.update({
  id: '/dev-configs',
  path: '/dev-configs',
  getParentRoute: () => AuthQaToolsRouteRoute,
} as any)
const AuthPartnerTargetsRoute = AuthPartnerTargetsRouteImport.update({
  id: '/targets',
  path: '/targets',
  getParentRoute: () => AuthPartnerRouteRoute,
} as any)
const AuthPartnerMappingRoute = AuthPartnerMappingRouteImport.update({
  id: '/mapping',
  path: '/mapping',
  getParentRoute: () => AuthPartnerRouteRoute,
} as any)
const AuthOverridesSessionRoute = AuthOverridesSessionRouteImport.update({
  id: '/session',
  path: '/session',
  getParentRoute: () => AuthOverridesRouteRoute,
} as any)
const AuthOverridesPlaybackRoute = AuthOverridesPlaybackRouteImport.update({
  id: '/playback',
  path: '/playback',
  getParentRoute: () => AuthOverridesRouteRoute,
} as any)
const AuthMilestonesGamePkRoute = AuthMilestonesGamePkRouteImport.update({
  id: '/$gamePk',
  path: '/$gamePk',
  getParentRoute: () => AuthMilestonesRouteRoute,
} as any)
const AuthMediaValidationPlayerValidatorRoute =
  AuthMediaValidationPlayerValidatorRouteImport.update({
    id: '/player-validator',
    path: '/player-validator',
    getParentRoute: () => AuthMediaValidationRouteRoute,
  } as any)
const AuthMediaValidationLitmusRoute =
  AuthMediaValidationLitmusRouteImport.update({
    id: '/litmus',
    path: '/litmus',
    getParentRoute: () => AuthMediaValidationRouteRoute,
  } as any)
const AuthLoggerGamePkRoute = AuthLoggerGamePkRouteImport.update({
  id: '/$gamePk',
  path: '/$gamePk',
  getParentRoute: () => AuthLoggerRouteRoute,
} as any)
const AuthIpOverrideUserLookupRoute =
  AuthIpOverrideUserLookupRouteImport.update({
    id: '/user-lookup',
    path: '/user-lookup',
    getParentRoute: () => AuthIpOverrideRouteRoute,
  } as any)
const AuthIpOverrideOverridesRoute = AuthIpOverrideOverridesRouteImport.update({
  id: '/overrides',
  path: '/overrides',
  getParentRoute: () => AuthIpOverrideRouteRoute,
} as any)
const AuthEsniPoliciesRoute = AuthEsniPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => AuthEsniRouteRoute,
} as any)
const AuthEsniMediaRoute = AuthEsniMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AuthEsniRouteRoute,
} as any)
const AuthEsniAudiencesRoute = AuthEsniAudiencesRouteImport.update({
  id: '/audiences',
  path: '/audiences',
  getParentRoute: () => AuthEsniRouteRoute,
} as any)
const AuthBtcToolsTeamZixiSourcesRoute =
  AuthBtcToolsTeamZixiSourcesRouteImport.update({
    id: '/team-zixi-sources',
    path: '/team-zixi-sources',
    getParentRoute: () => AuthBtcToolsRouteRoute,
  } as any)
const AuthBtcToolsCdnStatusRoute = AuthBtcToolsCdnStatusRouteImport.update({
  id: '/cdn-status',
  path: '/cdn-status',
  getParentRoute: () => AuthBtcToolsRouteRoute,
} as any)
const AuthBtcToolsBroadcastSourceOverridesRoute =
  AuthBtcToolsBroadcastSourceOverridesRouteImport.update({
    id: '/broadcast-source-overrides',
    path: '/broadcast-source-overrides',
    getParentRoute: () => AuthBtcToolsRouteRoute,
  } as any)
const AuthAuditScheduleRoute = AuthAuditScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AuthAuditRouteRoute,
} as any)
const AuthAuditAuditsRoute = AuthAuditAuditsRouteImport.update({
  id: '/audits',
  path: '/audits',
  getParentRoute: () => AuthAuditRouteRoute,
} as any)
const AuthBtcToolsScheduleRouteRoute =
  AuthBtcToolsScheduleRouteRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AuthBtcToolsRouteRoute,
  } as any)
const AuthBtcToolsConfigsRouteRoute =
  AuthBtcToolsConfigsRouteRouteImport.update({
    id: '/configs',
    path: '/configs',
    getParentRoute: () => AuthBtcToolsRouteRoute,
  } as any)
const AuthEsniRulesIndexRoute = AuthEsniRulesIndexRouteImport.update({
  id: '/rules/',
  path: '/rules/',
  getParentRoute: () => AuthEsniRouteRoute,
} as any)
const AuthBtcToolsScheduleIndexRoute =
  AuthBtcToolsScheduleIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthBtcToolsScheduleRouteRoute,
  } as any)
const AuthEsniRulesProcessRoute = AuthEsniRulesProcessRouteImport.update({
  id: '/rules/process',
  path: '/rules/process',
  getParentRoute: () => AuthEsniRouteRoute,
} as any)
const AuthEsniRulesCreateRoute = AuthEsniRulesCreateRouteImport.update({
  id: '/rules/create',
  path: '/rules/create',
  getParentRoute: () => AuthEsniRouteRoute,
} as any)
const AuthEsniRulesRuleIdRoute = AuthEsniRulesRuleIdRouteImport.update({
  id: '/rules/$ruleId',
  path: '/rules/$ruleId',
  getParentRoute: () => AuthEsniRouteRoute,
} as any)
const AuthBtcToolsConfigsSkyviewRoute =
  AuthBtcToolsConfigsSkyviewRouteImport.update({
    id: '/skyview',
    path: '/skyview',
    getParentRoute: () => AuthBtcToolsConfigsRouteRoute,
  } as any)
const AuthBtcToolsConfigsPipelineInputRoute =
  AuthBtcToolsConfigsPipelineInputRouteImport.update({
    id: '/pipeline-input',
    path: '/pipeline-input',
    getParentRoute: () => AuthBtcToolsConfigsRouteRoute,
  } as any)
const AuthBtcToolsConfigsPipelineRoute =
  AuthBtcToolsConfigsPipelineRouteImport.update({
    id: '/pipeline',
    path: '/pipeline',
    getParentRoute: () => AuthBtcToolsConfigsRouteRoute,
  } as any)
const AuthBtcToolsConfigsMulticastMappingsRoute =
  AuthBtcToolsConfigsMulticastMappingsRouteImport.update({
    id: '/multicast-mappings',
    path: '/multicast-mappings',
    getParentRoute: () => AuthBtcToolsConfigsRouteRoute,
  } as any)
const AuthBtcToolsScheduleGamePkRouteRoute =
  AuthBtcToolsScheduleGamePkRouteRouteImport.update({
    id: '/$gamePk',
    path: '/$gamePk',
    getParentRoute: () => AuthBtcToolsScheduleRouteRoute,
  } as any)
const AuthBtcToolsScheduleGamePkContentRoute =
  AuthBtcToolsScheduleGamePkContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => AuthBtcToolsScheduleGamePkRouteRoute,
  } as any)
const AuthBtcToolsScheduleGamePkPipelinesIndexRoute =
  AuthBtcToolsScheduleGamePkPipelinesIndexRouteImport.update({
    id: '/pipelines/',
    path: '/pipelines/',
    getParentRoute: () => AuthBtcToolsScheduleGamePkRouteRoute,
  } as any)
const AuthBtcToolsScheduleGamePkBroadcastsIndexRoute =
  AuthBtcToolsScheduleGamePkBroadcastsIndexRouteImport.update({
    id: '/broadcasts/',
    path: '/broadcasts/',
    getParentRoute: () => AuthBtcToolsScheduleGamePkRouteRoute,
  } as any)
const AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRoute =
  AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRouteImport.update({
    id: '/broadcast-acquisitions/',
    path: '/broadcast-acquisitions/',
    getParentRoute: () => AuthBtcToolsScheduleGamePkRouteRoute,
  } as any)
const AuthBtcToolsScheduleGamePkPipelinesPipelineIdRoute =
  AuthBtcToolsScheduleGamePkPipelinesPipelineIdRouteImport.update({
    id: '/pipelines/$pipelineId',
    path: '/pipelines/$pipelineId',
    getParentRoute: () => AuthBtcToolsScheduleGamePkRouteRoute,
  } as any)
const AuthBtcToolsScheduleGamePkBroadcastsMediaIdRoute =
  AuthBtcToolsScheduleGamePkBroadcastsMediaIdRouteImport.update({
    id: '/broadcasts/$mediaId',
    path: '/broadcasts/$mediaId',
    getParentRoute: () => AuthBtcToolsScheduleGamePkRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/sandbox': typeof SandboxRoute
  '/audit': typeof AuthAuditRouteRouteWithChildren
  '/btc-tools': typeof AuthBtcToolsRouteRouteWithChildren
  '/esni': typeof AuthEsniRouteRouteWithChildren
  '/ip-override': typeof AuthIpOverrideRouteRouteWithChildren
  '/logger': typeof AuthLoggerRouteRouteWithChildren
  '/media-validation': typeof AuthMediaValidationRouteRouteWithChildren
  '/milestones': typeof AuthMilestonesRouteRouteWithChildren
  '/overrides': typeof AuthOverridesRouteRouteWithChildren
  '/partner': typeof AuthPartnerRouteRouteWithChildren
  '/qa-tools': typeof AuthQaToolsRouteRouteWithChildren
  '/user-lookup': typeof AuthUserLookupRouteRouteWithChildren
  '/unauthorized': typeof AuthUnauthorizedRoute
  '/implicit/callback': typeof ImplicitCallbackRoute
  '/secure/$': typeof SecureSplatRoute
  '/btc-tools/configs': typeof AuthBtcToolsConfigsRouteRouteWithChildren
  '/btc-tools/schedule': typeof AuthBtcToolsScheduleRouteRouteWithChildren
  '/audit/audits': typeof AuthAuditAuditsRoute
  '/audit/schedule': typeof AuthAuditScheduleRoute
  '/btc-tools/broadcast-source-overrides': typeof AuthBtcToolsBroadcastSourceOverridesRoute
  '/btc-tools/cdn-status': typeof AuthBtcToolsCdnStatusRoute
  '/btc-tools/team-zixi-sources': typeof AuthBtcToolsTeamZixiSourcesRoute
  '/esni/audiences': typeof AuthEsniAudiencesRoute
  '/esni/media': typeof AuthEsniMediaRoute
  '/esni/policies': typeof AuthEsniPoliciesRoute
  '/ip-override/overrides': typeof AuthIpOverrideOverridesRoute
  '/ip-override/user-lookup': typeof AuthIpOverrideUserLookupRoute
  '/logger/$gamePk': typeof AuthLoggerGamePkRoute
  '/media-validation/litmus': typeof AuthMediaValidationLitmusRoute
  '/media-validation/player-validator': typeof AuthMediaValidationPlayerValidatorRoute
  '/milestones/$gamePk': typeof AuthMilestonesGamePkRoute
  '/overrides/playback': typeof AuthOverridesPlaybackRoute
  '/overrides/session': typeof AuthOverridesSessionRoute
  '/partner/mapping': typeof AuthPartnerMappingRoute
  '/partner/targets': typeof AuthPartnerTargetsRoute
  '/qa-tools/dev-configs': typeof AuthQaToolsDevConfigsRoute
  '/audit/': typeof AuthAuditIndexRoute
  '/btc-tools/': typeof AuthBtcToolsIndexRoute
  '/esni/': typeof AuthEsniIndexRoute
  '/ip-override/': typeof AuthIpOverrideIndexRoute
  '/logger/': typeof AuthLoggerIndexRoute
  '/media-validation/': typeof AuthMediaValidationIndexRoute
  '/milestones/': typeof AuthMilestonesIndexRoute
  '/overrides/': typeof AuthOverridesIndexRoute
  '/partner/': typeof AuthPartnerIndexRoute
  '/qa-tools/': typeof AuthQaToolsIndexRoute
  '/user-lookup/': typeof AuthUserLookupIndexRoute
  '/btc-tools/schedule/$gamePk': typeof AuthBtcToolsScheduleGamePkRouteRouteWithChildren
  '/btc-tools/configs/multicast-mappings': typeof AuthBtcToolsConfigsMulticastMappingsRoute
  '/btc-tools/configs/pipeline': typeof AuthBtcToolsConfigsPipelineRoute
  '/btc-tools/configs/pipeline-input': typeof AuthBtcToolsConfigsPipelineInputRoute
  '/btc-tools/configs/skyview': typeof AuthBtcToolsConfigsSkyviewRoute
  '/esni/rules/$ruleId': typeof AuthEsniRulesRuleIdRoute
  '/esni/rules/create': typeof AuthEsniRulesCreateRoute
  '/esni/rules/process': typeof AuthEsniRulesProcessRoute
  '/btc-tools/schedule/': typeof AuthBtcToolsScheduleIndexRoute
  '/esni/rules': typeof AuthEsniRulesIndexRoute
  '/btc-tools/schedule/$gamePk/content': typeof AuthBtcToolsScheduleGamePkContentRoute
  '/btc-tools/schedule/$gamePk/broadcasts/$mediaId': typeof AuthBtcToolsScheduleGamePkBroadcastsMediaIdRoute
  '/btc-tools/schedule/$gamePk/pipelines/$pipelineId': typeof AuthBtcToolsScheduleGamePkPipelinesPipelineIdRoute
  '/btc-tools/schedule/$gamePk/broadcast-acquisitions': typeof AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRoute
  '/btc-tools/schedule/$gamePk/broadcasts': typeof AuthBtcToolsScheduleGamePkBroadcastsIndexRoute
  '/btc-tools/schedule/$gamePk/pipelines': typeof AuthBtcToolsScheduleGamePkPipelinesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/sandbox': typeof SandboxRoute
  '/unauthorized': typeof AuthUnauthorizedRoute
  '/implicit/callback': typeof ImplicitCallbackRoute
  '/secure/$': typeof SecureSplatRoute
  '/btc-tools/configs': typeof AuthBtcToolsConfigsRouteRouteWithChildren
  '/audit/audits': typeof AuthAuditAuditsRoute
  '/audit/schedule': typeof AuthAuditScheduleRoute
  '/btc-tools/broadcast-source-overrides': typeof AuthBtcToolsBroadcastSourceOverridesRoute
  '/btc-tools/cdn-status': typeof AuthBtcToolsCdnStatusRoute
  '/btc-tools/team-zixi-sources': typeof AuthBtcToolsTeamZixiSourcesRoute
  '/esni/audiences': typeof AuthEsniAudiencesRoute
  '/esni/media': typeof AuthEsniMediaRoute
  '/esni/policies': typeof AuthEsniPoliciesRoute
  '/ip-override/overrides': typeof AuthIpOverrideOverridesRoute
  '/ip-override/user-lookup': typeof AuthIpOverrideUserLookupRoute
  '/logger/$gamePk': typeof AuthLoggerGamePkRoute
  '/media-validation/litmus': typeof AuthMediaValidationLitmusRoute
  '/media-validation/player-validator': typeof AuthMediaValidationPlayerValidatorRoute
  '/milestones/$gamePk': typeof AuthMilestonesGamePkRoute
  '/overrides/playback': typeof AuthOverridesPlaybackRoute
  '/overrides/session': typeof AuthOverridesSessionRoute
  '/partner/mapping': typeof AuthPartnerMappingRoute
  '/partner/targets': typeof AuthPartnerTargetsRoute
  '/qa-tools/dev-configs': typeof AuthQaToolsDevConfigsRoute
  '/audit': typeof AuthAuditIndexRoute
  '/btc-tools': typeof AuthBtcToolsIndexRoute
  '/esni': typeof AuthEsniIndexRoute
  '/ip-override': typeof AuthIpOverrideIndexRoute
  '/logger': typeof AuthLoggerIndexRoute
  '/media-validation': typeof AuthMediaValidationIndexRoute
  '/milestones': typeof AuthMilestonesIndexRoute
  '/overrides': typeof AuthOverridesIndexRoute
  '/partner': typeof AuthPartnerIndexRoute
  '/qa-tools': typeof AuthQaToolsIndexRoute
  '/user-lookup': typeof AuthUserLookupIndexRoute
  '/btc-tools/schedule/$gamePk': typeof AuthBtcToolsScheduleGamePkRouteRouteWithChildren
  '/btc-tools/configs/multicast-mappings': typeof AuthBtcToolsConfigsMulticastMappingsRoute
  '/btc-tools/configs/pipeline': typeof AuthBtcToolsConfigsPipelineRoute
  '/btc-tools/configs/pipeline-input': typeof AuthBtcToolsConfigsPipelineInputRoute
  '/btc-tools/configs/skyview': typeof AuthBtcToolsConfigsSkyviewRoute
  '/esni/rules/$ruleId': typeof AuthEsniRulesRuleIdRoute
  '/esni/rules/create': typeof AuthEsniRulesCreateRoute
  '/esni/rules/process': typeof AuthEsniRulesProcessRoute
  '/btc-tools/schedule': typeof AuthBtcToolsScheduleIndexRoute
  '/esni/rules': typeof AuthEsniRulesIndexRoute
  '/btc-tools/schedule/$gamePk/content': typeof AuthBtcToolsScheduleGamePkContentRoute
  '/btc-tools/schedule/$gamePk/broadcasts/$mediaId': typeof AuthBtcToolsScheduleGamePkBroadcastsMediaIdRoute
  '/btc-tools/schedule/$gamePk/pipelines/$pipelineId': typeof AuthBtcToolsScheduleGamePkPipelinesPipelineIdRoute
  '/btc-tools/schedule/$gamePk/broadcast-acquisitions': typeof AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRoute
  '/btc-tools/schedule/$gamePk/broadcasts': typeof AuthBtcToolsScheduleGamePkBroadcastsIndexRoute
  '/btc-tools/schedule/$gamePk/pipelines': typeof AuthBtcToolsScheduleGamePkPipelinesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/sandbox': typeof SandboxRoute
  '/_auth/audit': typeof AuthAuditRouteRouteWithChildren
  '/_auth/btc-tools': typeof AuthBtcToolsRouteRouteWithChildren
  '/_auth/esni': typeof AuthEsniRouteRouteWithChildren
  '/_auth/ip-override': typeof AuthIpOverrideRouteRouteWithChildren
  '/_auth/logger': typeof AuthLoggerRouteRouteWithChildren
  '/_auth/media-validation': typeof AuthMediaValidationRouteRouteWithChildren
  '/_auth/milestones': typeof AuthMilestonesRouteRouteWithChildren
  '/_auth/overrides': typeof AuthOverridesRouteRouteWithChildren
  '/_auth/partner': typeof AuthPartnerRouteRouteWithChildren
  '/_auth/qa-tools': typeof AuthQaToolsRouteRouteWithChildren
  '/_auth/user-lookup': typeof AuthUserLookupRouteRouteWithChildren
  '/_auth/unauthorized': typeof AuthUnauthorizedRoute
  '/implicit/callback': typeof ImplicitCallbackRoute
  '/secure/$': typeof SecureSplatRoute
  '/_auth/btc-tools/configs': typeof AuthBtcToolsConfigsRouteRouteWithChildren
  '/_auth/btc-tools/schedule': typeof AuthBtcToolsScheduleRouteRouteWithChildren
  '/_auth/audit/audits': typeof AuthAuditAuditsRoute
  '/_auth/audit/schedule': typeof AuthAuditScheduleRoute
  '/_auth/btc-tools/broadcast-source-overrides': typeof AuthBtcToolsBroadcastSourceOverridesRoute
  '/_auth/btc-tools/cdn-status': typeof AuthBtcToolsCdnStatusRoute
  '/_auth/btc-tools/team-zixi-sources': typeof AuthBtcToolsTeamZixiSourcesRoute
  '/_auth/esni/audiences': typeof AuthEsniAudiencesRoute
  '/_auth/esni/media': typeof AuthEsniMediaRoute
  '/_auth/esni/policies': typeof AuthEsniPoliciesRoute
  '/_auth/ip-override/overrides': typeof AuthIpOverrideOverridesRoute
  '/_auth/ip-override/user-lookup': typeof AuthIpOverrideUserLookupRoute
  '/_auth/logger/$gamePk': typeof AuthLoggerGamePkRoute
  '/_auth/media-validation/litmus': typeof AuthMediaValidationLitmusRoute
  '/_auth/media-validation/player-validator': typeof AuthMediaValidationPlayerValidatorRoute
  '/_auth/milestones/$gamePk': typeof AuthMilestonesGamePkRoute
  '/_auth/overrides/playback': typeof AuthOverridesPlaybackRoute
  '/_auth/overrides/session': typeof AuthOverridesSessionRoute
  '/_auth/partner/mapping': typeof AuthPartnerMappingRoute
  '/_auth/partner/targets': typeof AuthPartnerTargetsRoute
  '/_auth/qa-tools/dev-configs': typeof AuthQaToolsDevConfigsRoute
  '/_auth/audit/': typeof AuthAuditIndexRoute
  '/_auth/btc-tools/': typeof AuthBtcToolsIndexRoute
  '/_auth/esni/': typeof AuthEsniIndexRoute
  '/_auth/ip-override/': typeof AuthIpOverrideIndexRoute
  '/_auth/logger/': typeof AuthLoggerIndexRoute
  '/_auth/media-validation/': typeof AuthMediaValidationIndexRoute
  '/_auth/milestones/': typeof AuthMilestonesIndexRoute
  '/_auth/overrides/': typeof AuthOverridesIndexRoute
  '/_auth/partner/': typeof AuthPartnerIndexRoute
  '/_auth/qa-tools/': typeof AuthQaToolsIndexRoute
  '/_auth/user-lookup/': typeof AuthUserLookupIndexRoute
  '/_auth/btc-tools/schedule/$gamePk': typeof AuthBtcToolsScheduleGamePkRouteRouteWithChildren
  '/_auth/btc-tools/configs/multicast-mappings': typeof AuthBtcToolsConfigsMulticastMappingsRoute
  '/_auth/btc-tools/configs/pipeline': typeof AuthBtcToolsConfigsPipelineRoute
  '/_auth/btc-tools/configs/pipeline-input': typeof AuthBtcToolsConfigsPipelineInputRoute
  '/_auth/btc-tools/configs/skyview': typeof AuthBtcToolsConfigsSkyviewRoute
  '/_auth/esni/rules/$ruleId': typeof AuthEsniRulesRuleIdRoute
  '/_auth/esni/rules/create': typeof AuthEsniRulesCreateRoute
  '/_auth/esni/rules/process': typeof AuthEsniRulesProcessRoute
  '/_auth/btc-tools/schedule/': typeof AuthBtcToolsScheduleIndexRoute
  '/_auth/esni/rules/': typeof AuthEsniRulesIndexRoute
  '/_auth/btc-tools/schedule/$gamePk/content': typeof AuthBtcToolsScheduleGamePkContentRoute
  '/_auth/btc-tools/schedule/$gamePk/broadcasts/$mediaId': typeof AuthBtcToolsScheduleGamePkBroadcastsMediaIdRoute
  '/_auth/btc-tools/schedule/$gamePk/pipelines/$pipelineId': typeof AuthBtcToolsScheduleGamePkPipelinesPipelineIdRoute
  '/_auth/btc-tools/schedule/$gamePk/broadcast-acquisitions/': typeof AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRoute
  '/_auth/btc-tools/schedule/$gamePk/broadcasts/': typeof AuthBtcToolsScheduleGamePkBroadcastsIndexRoute
  '/_auth/btc-tools/schedule/$gamePk/pipelines/': typeof AuthBtcToolsScheduleGamePkPipelinesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/sandbox'
    | '/audit'
    | '/btc-tools'
    | '/esni'
    | '/ip-override'
    | '/logger'
    | '/media-validation'
    | '/milestones'
    | '/overrides'
    | '/partner'
    | '/qa-tools'
    | '/user-lookup'
    | '/unauthorized'
    | '/implicit/callback'
    | '/secure/$'
    | '/btc-tools/configs'
    | '/btc-tools/schedule'
    | '/audit/audits'
    | '/audit/schedule'
    | '/btc-tools/broadcast-source-overrides'
    | '/btc-tools/cdn-status'
    | '/btc-tools/team-zixi-sources'
    | '/esni/audiences'
    | '/esni/media'
    | '/esni/policies'
    | '/ip-override/overrides'
    | '/ip-override/user-lookup'
    | '/logger/$gamePk'
    | '/media-validation/litmus'
    | '/media-validation/player-validator'
    | '/milestones/$gamePk'
    | '/overrides/playback'
    | '/overrides/session'
    | '/partner/mapping'
    | '/partner/targets'
    | '/qa-tools/dev-configs'
    | '/audit/'
    | '/btc-tools/'
    | '/esni/'
    | '/ip-override/'
    | '/logger/'
    | '/media-validation/'
    | '/milestones/'
    | '/overrides/'
    | '/partner/'
    | '/qa-tools/'
    | '/user-lookup/'
    | '/btc-tools/schedule/$gamePk'
    | '/btc-tools/configs/multicast-mappings'
    | '/btc-tools/configs/pipeline'
    | '/btc-tools/configs/pipeline-input'
    | '/btc-tools/configs/skyview'
    | '/esni/rules/$ruleId'
    | '/esni/rules/create'
    | '/esni/rules/process'
    | '/btc-tools/schedule/'
    | '/esni/rules'
    | '/btc-tools/schedule/$gamePk/content'
    | '/btc-tools/schedule/$gamePk/broadcasts/$mediaId'
    | '/btc-tools/schedule/$gamePk/pipelines/$pipelineId'
    | '/btc-tools/schedule/$gamePk/broadcast-acquisitions'
    | '/btc-tools/schedule/$gamePk/broadcasts'
    | '/btc-tools/schedule/$gamePk/pipelines'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/sandbox'
    | '/unauthorized'
    | '/implicit/callback'
    | '/secure/$'
    | '/btc-tools/configs'
    | '/audit/audits'
    | '/audit/schedule'
    | '/btc-tools/broadcast-source-overrides'
    | '/btc-tools/cdn-status'
    | '/btc-tools/team-zixi-sources'
    | '/esni/audiences'
    | '/esni/media'
    | '/esni/policies'
    | '/ip-override/overrides'
    | '/ip-override/user-lookup'
    | '/logger/$gamePk'
    | '/media-validation/litmus'
    | '/media-validation/player-validator'
    | '/milestones/$gamePk'
    | '/overrides/playback'
    | '/overrides/session'
    | '/partner/mapping'
    | '/partner/targets'
    | '/qa-tools/dev-configs'
    | '/audit'
    | '/btc-tools'
    | '/esni'
    | '/ip-override'
    | '/logger'
    | '/media-validation'
    | '/milestones'
    | '/overrides'
    | '/partner'
    | '/qa-tools'
    | '/user-lookup'
    | '/btc-tools/schedule/$gamePk'
    | '/btc-tools/configs/multicast-mappings'
    | '/btc-tools/configs/pipeline'
    | '/btc-tools/configs/pipeline-input'
    | '/btc-tools/configs/skyview'
    | '/esni/rules/$ruleId'
    | '/esni/rules/create'
    | '/esni/rules/process'
    | '/btc-tools/schedule'
    | '/esni/rules'
    | '/btc-tools/schedule/$gamePk/content'
    | '/btc-tools/schedule/$gamePk/broadcasts/$mediaId'
    | '/btc-tools/schedule/$gamePk/pipelines/$pipelineId'
    | '/btc-tools/schedule/$gamePk/broadcast-acquisitions'
    | '/btc-tools/schedule/$gamePk/broadcasts'
    | '/btc-tools/schedule/$gamePk/pipelines'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/sandbox'
    | '/_auth/audit'
    | '/_auth/btc-tools'
    | '/_auth/esni'
    | '/_auth/ip-override'
    | '/_auth/logger'
    | '/_auth/media-validation'
    | '/_auth/milestones'
    | '/_auth/overrides'
    | '/_auth/partner'
    | '/_auth/qa-tools'
    | '/_auth/user-lookup'
    | '/_auth/unauthorized'
    | '/implicit/callback'
    | '/secure/$'
    | '/_auth/btc-tools/configs'
    | '/_auth/btc-tools/schedule'
    | '/_auth/audit/audits'
    | '/_auth/audit/schedule'
    | '/_auth/btc-tools/broadcast-source-overrides'
    | '/_auth/btc-tools/cdn-status'
    | '/_auth/btc-tools/team-zixi-sources'
    | '/_auth/esni/audiences'
    | '/_auth/esni/media'
    | '/_auth/esni/policies'
    | '/_auth/ip-override/overrides'
    | '/_auth/ip-override/user-lookup'
    | '/_auth/logger/$gamePk'
    | '/_auth/media-validation/litmus'
    | '/_auth/media-validation/player-validator'
    | '/_auth/milestones/$gamePk'
    | '/_auth/overrides/playback'
    | '/_auth/overrides/session'
    | '/_auth/partner/mapping'
    | '/_auth/partner/targets'
    | '/_auth/qa-tools/dev-configs'
    | '/_auth/audit/'
    | '/_auth/btc-tools/'
    | '/_auth/esni/'
    | '/_auth/ip-override/'
    | '/_auth/logger/'
    | '/_auth/media-validation/'
    | '/_auth/milestones/'
    | '/_auth/overrides/'
    | '/_auth/partner/'
    | '/_auth/qa-tools/'
    | '/_auth/user-lookup/'
    | '/_auth/btc-tools/schedule/$gamePk'
    | '/_auth/btc-tools/configs/multicast-mappings'
    | '/_auth/btc-tools/configs/pipeline'
    | '/_auth/btc-tools/configs/pipeline-input'
    | '/_auth/btc-tools/configs/skyview'
    | '/_auth/esni/rules/$ruleId'
    | '/_auth/esni/rules/create'
    | '/_auth/esni/rules/process'
    | '/_auth/btc-tools/schedule/'
    | '/_auth/esni/rules/'
    | '/_auth/btc-tools/schedule/$gamePk/content'
    | '/_auth/btc-tools/schedule/$gamePk/broadcasts/$mediaId'
    | '/_auth/btc-tools/schedule/$gamePk/pipelines/$pipelineId'
    | '/_auth/btc-tools/schedule/$gamePk/broadcast-acquisitions/'
    | '/_auth/btc-tools/schedule/$gamePk/broadcasts/'
    | '/_auth/btc-tools/schedule/$gamePk/pipelines/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  SandboxRoute: typeof SandboxRoute
  ImplicitCallbackRoute: typeof ImplicitCallbackRoute
  SecureSplatRoute: typeof SecureSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sandbox': {
      id: '/sandbox'
      path: '/sandbox'
      fullPath: '/sandbox'
      preLoaderRoute: typeof SandboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secure/$': {
      id: '/secure/$'
      path: '/secure/$'
      fullPath: '/secure/$'
      preLoaderRoute: typeof SecureSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/implicit/callback': {
      id: '/implicit/callback'
      path: '/implicit/callback'
      fullPath: '/implicit/callback'
      preLoaderRoute: typeof ImplicitCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/unauthorized': {
      id: '/_auth/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof AuthUnauthorizedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user-lookup': {
      id: '/_auth/user-lookup'
      path: '/user-lookup'
      fullPath: '/user-lookup'
      preLoaderRoute: typeof AuthUserLookupRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/qa-tools': {
      id: '/_auth/qa-tools'
      path: '/qa-tools'
      fullPath: '/qa-tools'
      preLoaderRoute: typeof AuthQaToolsRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/partner': {
      id: '/_auth/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof AuthPartnerRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/overrides': {
      id: '/_auth/overrides'
      path: '/overrides'
      fullPath: '/overrides'
      preLoaderRoute: typeof AuthOverridesRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/milestones': {
      id: '/_auth/milestones'
      path: '/milestones'
      fullPath: '/milestones'
      preLoaderRoute: typeof AuthMilestonesRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/media-validation': {
      id: '/_auth/media-validation'
      path: '/media-validation'
      fullPath: '/media-validation'
      preLoaderRoute: typeof AuthMediaValidationRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/logger': {
      id: '/_auth/logger'
      path: '/logger'
      fullPath: '/logger'
      preLoaderRoute: typeof AuthLoggerRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ip-override': {
      id: '/_auth/ip-override'
      path: '/ip-override'
      fullPath: '/ip-override'
      preLoaderRoute: typeof AuthIpOverrideRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/esni': {
      id: '/_auth/esni'
      path: '/esni'
      fullPath: '/esni'
      preLoaderRoute: typeof AuthEsniRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/btc-tools': {
      id: '/_auth/btc-tools'
      path: '/btc-tools'
      fullPath: '/btc-tools'
      preLoaderRoute: typeof AuthBtcToolsRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit': {
      id: '/_auth/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthAuditRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user-lookup/': {
      id: '/_auth/user-lookup/'
      path: '/'
      fullPath: '/user-lookup/'
      preLoaderRoute: typeof AuthUserLookupIndexRouteImport
      parentRoute: typeof AuthUserLookupRouteRoute
    }
    '/_auth/qa-tools/': {
      id: '/_auth/qa-tools/'
      path: '/'
      fullPath: '/qa-tools/'
      preLoaderRoute: typeof AuthQaToolsIndexRouteImport
      parentRoute: typeof AuthQaToolsRouteRoute
    }
    '/_auth/partner/': {
      id: '/_auth/partner/'
      path: '/'
      fullPath: '/partner/'
      preLoaderRoute: typeof AuthPartnerIndexRouteImport
      parentRoute: typeof AuthPartnerRouteRoute
    }
    '/_auth/overrides/': {
      id: '/_auth/overrides/'
      path: '/'
      fullPath: '/overrides/'
      preLoaderRoute: typeof AuthOverridesIndexRouteImport
      parentRoute: typeof AuthOverridesRouteRoute
    }
    '/_auth/milestones/': {
      id: '/_auth/milestones/'
      path: '/'
      fullPath: '/milestones/'
      preLoaderRoute: typeof AuthMilestonesIndexRouteImport
      parentRoute: typeof AuthMilestonesRouteRoute
    }
    '/_auth/media-validation/': {
      id: '/_auth/media-validation/'
      path: '/'
      fullPath: '/media-validation/'
      preLoaderRoute: typeof AuthMediaValidationIndexRouteImport
      parentRoute: typeof AuthMediaValidationRouteRoute
    }
    '/_auth/logger/': {
      id: '/_auth/logger/'
      path: '/'
      fullPath: '/logger/'
      preLoaderRoute: typeof AuthLoggerIndexRouteImport
      parentRoute: typeof AuthLoggerRouteRoute
    }
    '/_auth/ip-override/': {
      id: '/_auth/ip-override/'
      path: '/'
      fullPath: '/ip-override/'
      preLoaderRoute: typeof AuthIpOverrideIndexRouteImport
      parentRoute: typeof AuthIpOverrideRouteRoute
    }
    '/_auth/esni/': {
      id: '/_auth/esni/'
      path: '/'
      fullPath: '/esni/'
      preLoaderRoute: typeof AuthEsniIndexRouteImport
      parentRoute: typeof AuthEsniRouteRoute
    }
    '/_auth/btc-tools/': {
      id: '/_auth/btc-tools/'
      path: '/'
      fullPath: '/btc-tools/'
      preLoaderRoute: typeof AuthBtcToolsIndexRouteImport
      parentRoute: typeof AuthBtcToolsRouteRoute
    }
    '/_auth/audit/': {
      id: '/_auth/audit/'
      path: '/'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuthAuditIndexRouteImport
      parentRoute: typeof AuthAuditRouteRoute
    }
    '/_auth/qa-tools/dev-configs': {
      id: '/_auth/qa-tools/dev-configs'
      path: '/dev-configs'
      fullPath: '/qa-tools/dev-configs'
      preLoaderRoute: typeof AuthQaToolsDevConfigsRouteImport
      parentRoute: typeof AuthQaToolsRouteRoute
    }
    '/_auth/partner/targets': {
      id: '/_auth/partner/targets'
      path: '/targets'
      fullPath: '/partner/targets'
      preLoaderRoute: typeof AuthPartnerTargetsRouteImport
      parentRoute: typeof AuthPartnerRouteRoute
    }
    '/_auth/partner/mapping': {
      id: '/_auth/partner/mapping'
      path: '/mapping'
      fullPath: '/partner/mapping'
      preLoaderRoute: typeof AuthPartnerMappingRouteImport
      parentRoute: typeof AuthPartnerRouteRoute
    }
    '/_auth/overrides/session': {
      id: '/_auth/overrides/session'
      path: '/session'
      fullPath: '/overrides/session'
      preLoaderRoute: typeof AuthOverridesSessionRouteImport
      parentRoute: typeof AuthOverridesRouteRoute
    }
    '/_auth/overrides/playback': {
      id: '/_auth/overrides/playback'
      path: '/playback'
      fullPath: '/overrides/playback'
      preLoaderRoute: typeof AuthOverridesPlaybackRouteImport
      parentRoute: typeof AuthOverridesRouteRoute
    }
    '/_auth/milestones/$gamePk': {
      id: '/_auth/milestones/$gamePk'
      path: '/$gamePk'
      fullPath: '/milestones/$gamePk'
      preLoaderRoute: typeof AuthMilestonesGamePkRouteImport
      parentRoute: typeof AuthMilestonesRouteRoute
    }
    '/_auth/media-validation/player-validator': {
      id: '/_auth/media-validation/player-validator'
      path: '/player-validator'
      fullPath: '/media-validation/player-validator'
      preLoaderRoute: typeof AuthMediaValidationPlayerValidatorRouteImport
      parentRoute: typeof AuthMediaValidationRouteRoute
    }
    '/_auth/media-validation/litmus': {
      id: '/_auth/media-validation/litmus'
      path: '/litmus'
      fullPath: '/media-validation/litmus'
      preLoaderRoute: typeof AuthMediaValidationLitmusRouteImport
      parentRoute: typeof AuthMediaValidationRouteRoute
    }
    '/_auth/logger/$gamePk': {
      id: '/_auth/logger/$gamePk'
      path: '/$gamePk'
      fullPath: '/logger/$gamePk'
      preLoaderRoute: typeof AuthLoggerGamePkRouteImport
      parentRoute: typeof AuthLoggerRouteRoute
    }
    '/_auth/ip-override/user-lookup': {
      id: '/_auth/ip-override/user-lookup'
      path: '/user-lookup'
      fullPath: '/ip-override/user-lookup'
      preLoaderRoute: typeof AuthIpOverrideUserLookupRouteImport
      parentRoute: typeof AuthIpOverrideRouteRoute
    }
    '/_auth/ip-override/overrides': {
      id: '/_auth/ip-override/overrides'
      path: '/overrides'
      fullPath: '/ip-override/overrides'
      preLoaderRoute: typeof AuthIpOverrideOverridesRouteImport
      parentRoute: typeof AuthIpOverrideRouteRoute
    }
    '/_auth/esni/policies': {
      id: '/_auth/esni/policies'
      path: '/policies'
      fullPath: '/esni/policies'
      preLoaderRoute: typeof AuthEsniPoliciesRouteImport
      parentRoute: typeof AuthEsniRouteRoute
    }
    '/_auth/esni/media': {
      id: '/_auth/esni/media'
      path: '/media'
      fullPath: '/esni/media'
      preLoaderRoute: typeof AuthEsniMediaRouteImport
      parentRoute: typeof AuthEsniRouteRoute
    }
    '/_auth/esni/audiences': {
      id: '/_auth/esni/audiences'
      path: '/audiences'
      fullPath: '/esni/audiences'
      preLoaderRoute: typeof AuthEsniAudiencesRouteImport
      parentRoute: typeof AuthEsniRouteRoute
    }
    '/_auth/btc-tools/team-zixi-sources': {
      id: '/_auth/btc-tools/team-zixi-sources'
      path: '/team-zixi-sources'
      fullPath: '/btc-tools/team-zixi-sources'
      preLoaderRoute: typeof AuthBtcToolsTeamZixiSourcesRouteImport
      parentRoute: typeof AuthBtcToolsRouteRoute
    }
    '/_auth/btc-tools/cdn-status': {
      id: '/_auth/btc-tools/cdn-status'
      path: '/cdn-status'
      fullPath: '/btc-tools/cdn-status'
      preLoaderRoute: typeof AuthBtcToolsCdnStatusRouteImport
      parentRoute: typeof AuthBtcToolsRouteRoute
    }
    '/_auth/btc-tools/broadcast-source-overrides': {
      id: '/_auth/btc-tools/broadcast-source-overrides'
      path: '/broadcast-source-overrides'
      fullPath: '/btc-tools/broadcast-source-overrides'
      preLoaderRoute: typeof AuthBtcToolsBroadcastSourceOverridesRouteImport
      parentRoute: typeof AuthBtcToolsRouteRoute
    }
    '/_auth/audit/schedule': {
      id: '/_auth/audit/schedule'
      path: '/schedule'
      fullPath: '/audit/schedule'
      preLoaderRoute: typeof AuthAuditScheduleRouteImport
      parentRoute: typeof AuthAuditRouteRoute
    }
    '/_auth/audit/audits': {
      id: '/_auth/audit/audits'
      path: '/audits'
      fullPath: '/audit/audits'
      preLoaderRoute: typeof AuthAuditAuditsRouteImport
      parentRoute: typeof AuthAuditRouteRoute
    }
    '/_auth/btc-tools/schedule': {
      id: '/_auth/btc-tools/schedule'
      path: '/schedule'
      fullPath: '/btc-tools/schedule'
      preLoaderRoute: typeof AuthBtcToolsScheduleRouteRouteImport
      parentRoute: typeof AuthBtcToolsRouteRoute
    }
    '/_auth/btc-tools/configs': {
      id: '/_auth/btc-tools/configs'
      path: '/configs'
      fullPath: '/btc-tools/configs'
      preLoaderRoute: typeof AuthBtcToolsConfigsRouteRouteImport
      parentRoute: typeof AuthBtcToolsRouteRoute
    }
    '/_auth/esni/rules/': {
      id: '/_auth/esni/rules/'
      path: '/rules'
      fullPath: '/esni/rules'
      preLoaderRoute: typeof AuthEsniRulesIndexRouteImport
      parentRoute: typeof AuthEsniRouteRoute
    }
    '/_auth/btc-tools/schedule/': {
      id: '/_auth/btc-tools/schedule/'
      path: '/'
      fullPath: '/btc-tools/schedule/'
      preLoaderRoute: typeof AuthBtcToolsScheduleIndexRouteImport
      parentRoute: typeof AuthBtcToolsScheduleRouteRoute
    }
    '/_auth/esni/rules/process': {
      id: '/_auth/esni/rules/process'
      path: '/rules/process'
      fullPath: '/esni/rules/process'
      preLoaderRoute: typeof AuthEsniRulesProcessRouteImport
      parentRoute: typeof AuthEsniRouteRoute
    }
    '/_auth/esni/rules/create': {
      id: '/_auth/esni/rules/create'
      path: '/rules/create'
      fullPath: '/esni/rules/create'
      preLoaderRoute: typeof AuthEsniRulesCreateRouteImport
      parentRoute: typeof AuthEsniRouteRoute
    }
    '/_auth/esni/rules/$ruleId': {
      id: '/_auth/esni/rules/$ruleId'
      path: '/rules/$ruleId'
      fullPath: '/esni/rules/$ruleId'
      preLoaderRoute: typeof AuthEsniRulesRuleIdRouteImport
      parentRoute: typeof AuthEsniRouteRoute
    }
    '/_auth/btc-tools/configs/skyview': {
      id: '/_auth/btc-tools/configs/skyview'
      path: '/skyview'
      fullPath: '/btc-tools/configs/skyview'
      preLoaderRoute: typeof AuthBtcToolsConfigsSkyviewRouteImport
      parentRoute: typeof AuthBtcToolsConfigsRouteRoute
    }
    '/_auth/btc-tools/configs/pipeline-input': {
      id: '/_auth/btc-tools/configs/pipeline-input'
      path: '/pipeline-input'
      fullPath: '/btc-tools/configs/pipeline-input'
      preLoaderRoute: typeof AuthBtcToolsConfigsPipelineInputRouteImport
      parentRoute: typeof AuthBtcToolsConfigsRouteRoute
    }
    '/_auth/btc-tools/configs/pipeline': {
      id: '/_auth/btc-tools/configs/pipeline'
      path: '/pipeline'
      fullPath: '/btc-tools/configs/pipeline'
      preLoaderRoute: typeof AuthBtcToolsConfigsPipelineRouteImport
      parentRoute: typeof AuthBtcToolsConfigsRouteRoute
    }
    '/_auth/btc-tools/configs/multicast-mappings': {
      id: '/_auth/btc-tools/configs/multicast-mappings'
      path: '/multicast-mappings'
      fullPath: '/btc-tools/configs/multicast-mappings'
      preLoaderRoute: typeof AuthBtcToolsConfigsMulticastMappingsRouteImport
      parentRoute: typeof AuthBtcToolsConfigsRouteRoute
    }
    '/_auth/btc-tools/schedule/$gamePk': {
      id: '/_auth/btc-tools/schedule/$gamePk'
      path: '/$gamePk'
      fullPath: '/btc-tools/schedule/$gamePk'
      preLoaderRoute: typeof AuthBtcToolsScheduleGamePkRouteRouteImport
      parentRoute: typeof AuthBtcToolsScheduleRouteRoute
    }
    '/_auth/btc-tools/schedule/$gamePk/content': {
      id: '/_auth/btc-tools/schedule/$gamePk/content'
      path: '/content'
      fullPath: '/btc-tools/schedule/$gamePk/content'
      preLoaderRoute: typeof AuthBtcToolsScheduleGamePkContentRouteImport
      parentRoute: typeof AuthBtcToolsScheduleGamePkRouteRoute
    }
    '/_auth/btc-tools/schedule/$gamePk/pipelines/': {
      id: '/_auth/btc-tools/schedule/$gamePk/pipelines/'
      path: '/pipelines'
      fullPath: '/btc-tools/schedule/$gamePk/pipelines'
      preLoaderRoute: typeof AuthBtcToolsScheduleGamePkPipelinesIndexRouteImport
      parentRoute: typeof AuthBtcToolsScheduleGamePkRouteRoute
    }
    '/_auth/btc-tools/schedule/$gamePk/broadcasts/': {
      id: '/_auth/btc-tools/schedule/$gamePk/broadcasts/'
      path: '/broadcasts'
      fullPath: '/btc-tools/schedule/$gamePk/broadcasts'
      preLoaderRoute: typeof AuthBtcToolsScheduleGamePkBroadcastsIndexRouteImport
      parentRoute: typeof AuthBtcToolsScheduleGamePkRouteRoute
    }
    '/_auth/btc-tools/schedule/$gamePk/broadcast-acquisitions/': {
      id: '/_auth/btc-tools/schedule/$gamePk/broadcast-acquisitions/'
      path: '/broadcast-acquisitions'
      fullPath: '/btc-tools/schedule/$gamePk/broadcast-acquisitions'
      preLoaderRoute: typeof AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRouteImport
      parentRoute: typeof AuthBtcToolsScheduleGamePkRouteRoute
    }
    '/_auth/btc-tools/schedule/$gamePk/pipelines/$pipelineId': {
      id: '/_auth/btc-tools/schedule/$gamePk/pipelines/$pipelineId'
      path: '/pipelines/$pipelineId'
      fullPath: '/btc-tools/schedule/$gamePk/pipelines/$pipelineId'
      preLoaderRoute: typeof AuthBtcToolsScheduleGamePkPipelinesPipelineIdRouteImport
      parentRoute: typeof AuthBtcToolsScheduleGamePkRouteRoute
    }
    '/_auth/btc-tools/schedule/$gamePk/broadcasts/$mediaId': {
      id: '/_auth/btc-tools/schedule/$gamePk/broadcasts/$mediaId'
      path: '/broadcasts/$mediaId'
      fullPath: '/btc-tools/schedule/$gamePk/broadcasts/$mediaId'
      preLoaderRoute: typeof AuthBtcToolsScheduleGamePkBroadcastsMediaIdRouteImport
      parentRoute: typeof AuthBtcToolsScheduleGamePkRouteRoute
    }
  }
}

interface AuthAuditRouteRouteChildren {
  AuthAuditAuditsRoute: typeof AuthAuditAuditsRoute
  AuthAuditScheduleRoute: typeof AuthAuditScheduleRoute
  AuthAuditIndexRoute: typeof AuthAuditIndexRoute
}

const AuthAuditRouteRouteChildren: AuthAuditRouteRouteChildren = {
  AuthAuditAuditsRoute: AuthAuditAuditsRoute,
  AuthAuditScheduleRoute: AuthAuditScheduleRoute,
  AuthAuditIndexRoute: AuthAuditIndexRoute,
}

const AuthAuditRouteRouteWithChildren = AuthAuditRouteRoute._addFileChildren(
  AuthAuditRouteRouteChildren,
)

interface AuthBtcToolsConfigsRouteRouteChildren {
  AuthBtcToolsConfigsMulticastMappingsRoute: typeof AuthBtcToolsConfigsMulticastMappingsRoute
  AuthBtcToolsConfigsPipelineRoute: typeof AuthBtcToolsConfigsPipelineRoute
  AuthBtcToolsConfigsPipelineInputRoute: typeof AuthBtcToolsConfigsPipelineInputRoute
  AuthBtcToolsConfigsSkyviewRoute: typeof AuthBtcToolsConfigsSkyviewRoute
}

const AuthBtcToolsConfigsRouteRouteChildren: AuthBtcToolsConfigsRouteRouteChildren =
  {
    AuthBtcToolsConfigsMulticastMappingsRoute:
      AuthBtcToolsConfigsMulticastMappingsRoute,
    AuthBtcToolsConfigsPipelineRoute: AuthBtcToolsConfigsPipelineRoute,
    AuthBtcToolsConfigsPipelineInputRoute:
      AuthBtcToolsConfigsPipelineInputRoute,
    AuthBtcToolsConfigsSkyviewRoute: AuthBtcToolsConfigsSkyviewRoute,
  }

const AuthBtcToolsConfigsRouteRouteWithChildren =
  AuthBtcToolsConfigsRouteRoute._addFileChildren(
    AuthBtcToolsConfigsRouteRouteChildren,
  )

interface AuthBtcToolsScheduleGamePkRouteRouteChildren {
  AuthBtcToolsScheduleGamePkContentRoute: typeof AuthBtcToolsScheduleGamePkContentRoute
  AuthBtcToolsScheduleGamePkBroadcastsMediaIdRoute: typeof AuthBtcToolsScheduleGamePkBroadcastsMediaIdRoute
  AuthBtcToolsScheduleGamePkPipelinesPipelineIdRoute: typeof AuthBtcToolsScheduleGamePkPipelinesPipelineIdRoute
  AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRoute: typeof AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRoute
  AuthBtcToolsScheduleGamePkBroadcastsIndexRoute: typeof AuthBtcToolsScheduleGamePkBroadcastsIndexRoute
  AuthBtcToolsScheduleGamePkPipelinesIndexRoute: typeof AuthBtcToolsScheduleGamePkPipelinesIndexRoute
}

const AuthBtcToolsScheduleGamePkRouteRouteChildren: AuthBtcToolsScheduleGamePkRouteRouteChildren =
  {
    AuthBtcToolsScheduleGamePkContentRoute:
      AuthBtcToolsScheduleGamePkContentRoute,
    AuthBtcToolsScheduleGamePkBroadcastsMediaIdRoute:
      AuthBtcToolsScheduleGamePkBroadcastsMediaIdRoute,
    AuthBtcToolsScheduleGamePkPipelinesPipelineIdRoute:
      AuthBtcToolsScheduleGamePkPipelinesPipelineIdRoute,
    AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRoute:
      AuthBtcToolsScheduleGamePkBroadcastAcquisitionsIndexRoute,
    AuthBtcToolsScheduleGamePkBroadcastsIndexRoute:
      AuthBtcToolsScheduleGamePkBroadcastsIndexRoute,
    AuthBtcToolsScheduleGamePkPipelinesIndexRoute:
      AuthBtcToolsScheduleGamePkPipelinesIndexRoute,
  }

const AuthBtcToolsScheduleGamePkRouteRouteWithChildren =
  AuthBtcToolsScheduleGamePkRouteRoute._addFileChildren(
    AuthBtcToolsScheduleGamePkRouteRouteChildren,
  )

interface AuthBtcToolsScheduleRouteRouteChildren {
  AuthBtcToolsScheduleGamePkRouteRoute: typeof AuthBtcToolsScheduleGamePkRouteRouteWithChildren
  AuthBtcToolsScheduleIndexRoute: typeof AuthBtcToolsScheduleIndexRoute
}

const AuthBtcToolsScheduleRouteRouteChildren: AuthBtcToolsScheduleRouteRouteChildren =
  {
    AuthBtcToolsScheduleGamePkRouteRoute:
      AuthBtcToolsScheduleGamePkRouteRouteWithChildren,
    AuthBtcToolsScheduleIndexRoute: AuthBtcToolsScheduleIndexRoute,
  }

const AuthBtcToolsScheduleRouteRouteWithChildren =
  AuthBtcToolsScheduleRouteRoute._addFileChildren(
    AuthBtcToolsScheduleRouteRouteChildren,
  )

interface AuthBtcToolsRouteRouteChildren {
  AuthBtcToolsConfigsRouteRoute: typeof AuthBtcToolsConfigsRouteRouteWithChildren
  AuthBtcToolsScheduleRouteRoute: typeof AuthBtcToolsScheduleRouteRouteWithChildren
  AuthBtcToolsBroadcastSourceOverridesRoute: typeof AuthBtcToolsBroadcastSourceOverridesRoute
  AuthBtcToolsCdnStatusRoute: typeof AuthBtcToolsCdnStatusRoute
  AuthBtcToolsTeamZixiSourcesRoute: typeof AuthBtcToolsTeamZixiSourcesRoute
  AuthBtcToolsIndexRoute: typeof AuthBtcToolsIndexRoute
}

const AuthBtcToolsRouteRouteChildren: AuthBtcToolsRouteRouteChildren = {
  AuthBtcToolsConfigsRouteRoute: AuthBtcToolsConfigsRouteRouteWithChildren,
  AuthBtcToolsScheduleRouteRoute: AuthBtcToolsScheduleRouteRouteWithChildren,
  AuthBtcToolsBroadcastSourceOverridesRoute:
    AuthBtcToolsBroadcastSourceOverridesRoute,
  AuthBtcToolsCdnStatusRoute: AuthBtcToolsCdnStatusRoute,
  AuthBtcToolsTeamZixiSourcesRoute: AuthBtcToolsTeamZixiSourcesRoute,
  AuthBtcToolsIndexRoute: AuthBtcToolsIndexRoute,
}

const AuthBtcToolsRouteRouteWithChildren =
  AuthBtcToolsRouteRoute._addFileChildren(AuthBtcToolsRouteRouteChildren)

interface AuthEsniRouteRouteChildren {
  AuthEsniAudiencesRoute: typeof AuthEsniAudiencesRoute
  AuthEsniMediaRoute: typeof AuthEsniMediaRoute
  AuthEsniPoliciesRoute: typeof AuthEsniPoliciesRoute
  AuthEsniIndexRoute: typeof AuthEsniIndexRoute
  AuthEsniRulesRuleIdRoute: typeof AuthEsniRulesRuleIdRoute
  AuthEsniRulesCreateRoute: typeof AuthEsniRulesCreateRoute
  AuthEsniRulesProcessRoute: typeof AuthEsniRulesProcessRoute
  AuthEsniRulesIndexRoute: typeof AuthEsniRulesIndexRoute
}

const AuthEsniRouteRouteChildren: AuthEsniRouteRouteChildren = {
  AuthEsniAudiencesRoute: AuthEsniAudiencesRoute,
  AuthEsniMediaRoute: AuthEsniMediaRoute,
  AuthEsniPoliciesRoute: AuthEsniPoliciesRoute,
  AuthEsniIndexRoute: AuthEsniIndexRoute,
  AuthEsniRulesRuleIdRoute: AuthEsniRulesRuleIdRoute,
  AuthEsniRulesCreateRoute: AuthEsniRulesCreateRoute,
  AuthEsniRulesProcessRoute: AuthEsniRulesProcessRoute,
  AuthEsniRulesIndexRoute: AuthEsniRulesIndexRoute,
}

const AuthEsniRouteRouteWithChildren = AuthEsniRouteRoute._addFileChildren(
  AuthEsniRouteRouteChildren,
)

interface AuthIpOverrideRouteRouteChildren {
  AuthIpOverrideOverridesRoute: typeof AuthIpOverrideOverridesRoute
  AuthIpOverrideUserLookupRoute: typeof AuthIpOverrideUserLookupRoute
  AuthIpOverrideIndexRoute: typeof AuthIpOverrideIndexRoute
}

const AuthIpOverrideRouteRouteChildren: AuthIpOverrideRouteRouteChildren = {
  AuthIpOverrideOverridesRoute: AuthIpOverrideOverridesRoute,
  AuthIpOverrideUserLookupRoute: AuthIpOverrideUserLookupRoute,
  AuthIpOverrideIndexRoute: AuthIpOverrideIndexRoute,
}

const AuthIpOverrideRouteRouteWithChildren =
  AuthIpOverrideRouteRoute._addFileChildren(AuthIpOverrideRouteRouteChildren)

interface AuthLoggerRouteRouteChildren {
  AuthLoggerGamePkRoute: typeof AuthLoggerGamePkRoute
  AuthLoggerIndexRoute: typeof AuthLoggerIndexRoute
}

const AuthLoggerRouteRouteChildren: AuthLoggerRouteRouteChildren = {
  AuthLoggerGamePkRoute: AuthLoggerGamePkRoute,
  AuthLoggerIndexRoute: AuthLoggerIndexRoute,
}

const AuthLoggerRouteRouteWithChildren = AuthLoggerRouteRoute._addFileChildren(
  AuthLoggerRouteRouteChildren,
)

interface AuthMediaValidationRouteRouteChildren {
  AuthMediaValidationLitmusRoute: typeof AuthMediaValidationLitmusRoute
  AuthMediaValidationPlayerValidatorRoute: typeof AuthMediaValidationPlayerValidatorRoute
  AuthMediaValidationIndexRoute: typeof AuthMediaValidationIndexRoute
}

const AuthMediaValidationRouteRouteChildren: AuthMediaValidationRouteRouteChildren =
  {
    AuthMediaValidationLitmusRoute: AuthMediaValidationLitmusRoute,
    AuthMediaValidationPlayerValidatorRoute:
      AuthMediaValidationPlayerValidatorRoute,
    AuthMediaValidationIndexRoute: AuthMediaValidationIndexRoute,
  }

const AuthMediaValidationRouteRouteWithChildren =
  AuthMediaValidationRouteRoute._addFileChildren(
    AuthMediaValidationRouteRouteChildren,
  )

interface AuthMilestonesRouteRouteChildren {
  AuthMilestonesGamePkRoute: typeof AuthMilestonesGamePkRoute
  AuthMilestonesIndexRoute: typeof AuthMilestonesIndexRoute
}

const AuthMilestonesRouteRouteChildren: AuthMilestonesRouteRouteChildren = {
  AuthMilestonesGamePkRoute: AuthMilestonesGamePkRoute,
  AuthMilestonesIndexRoute: AuthMilestonesIndexRoute,
}

const AuthMilestonesRouteRouteWithChildren =
  AuthMilestonesRouteRoute._addFileChildren(AuthMilestonesRouteRouteChildren)

interface AuthOverridesRouteRouteChildren {
  AuthOverridesPlaybackRoute: typeof AuthOverridesPlaybackRoute
  AuthOverridesSessionRoute: typeof AuthOverridesSessionRoute
  AuthOverridesIndexRoute: typeof AuthOverridesIndexRoute
}

const AuthOverridesRouteRouteChildren: AuthOverridesRouteRouteChildren = {
  AuthOverridesPlaybackRoute: AuthOverridesPlaybackRoute,
  AuthOverridesSessionRoute: AuthOverridesSessionRoute,
  AuthOverridesIndexRoute: AuthOverridesIndexRoute,
}

const AuthOverridesRouteRouteWithChildren =
  AuthOverridesRouteRoute._addFileChildren(AuthOverridesRouteRouteChildren)

interface AuthPartnerRouteRouteChildren {
  AuthPartnerMappingRoute: typeof AuthPartnerMappingRoute
  AuthPartnerTargetsRoute: typeof AuthPartnerTargetsRoute
  AuthPartnerIndexRoute: typeof AuthPartnerIndexRoute
}

const AuthPartnerRouteRouteChildren: AuthPartnerRouteRouteChildren = {
  AuthPartnerMappingRoute: AuthPartnerMappingRoute,
  AuthPartnerTargetsRoute: AuthPartnerTargetsRoute,
  AuthPartnerIndexRoute: AuthPartnerIndexRoute,
}

const AuthPartnerRouteRouteWithChildren =
  AuthPartnerRouteRoute._addFileChildren(AuthPartnerRouteRouteChildren)

interface AuthQaToolsRouteRouteChildren {
  AuthQaToolsDevConfigsRoute: typeof AuthQaToolsDevConfigsRoute
  AuthQaToolsIndexRoute: typeof AuthQaToolsIndexRoute
}

const AuthQaToolsRouteRouteChildren: AuthQaToolsRouteRouteChildren = {
  AuthQaToolsDevConfigsRoute: AuthQaToolsDevConfigsRoute,
  AuthQaToolsIndexRoute: AuthQaToolsIndexRoute,
}

const AuthQaToolsRouteRouteWithChildren =
  AuthQaToolsRouteRoute._addFileChildren(AuthQaToolsRouteRouteChildren)

interface AuthUserLookupRouteRouteChildren {
  AuthUserLookupIndexRoute: typeof AuthUserLookupIndexRoute
}

const AuthUserLookupRouteRouteChildren: AuthUserLookupRouteRouteChildren = {
  AuthUserLookupIndexRoute: AuthUserLookupIndexRoute,
}

const AuthUserLookupRouteRouteWithChildren =
  AuthUserLookupRouteRoute._addFileChildren(AuthUserLookupRouteRouteChildren)

interface AuthRouteChildren {
  AuthAuditRouteRoute: typeof AuthAuditRouteRouteWithChildren
  AuthBtcToolsRouteRoute: typeof AuthBtcToolsRouteRouteWithChildren
  AuthEsniRouteRoute: typeof AuthEsniRouteRouteWithChildren
  AuthIpOverrideRouteRoute: typeof AuthIpOverrideRouteRouteWithChildren
  AuthLoggerRouteRoute: typeof AuthLoggerRouteRouteWithChildren
  AuthMediaValidationRouteRoute: typeof AuthMediaValidationRouteRouteWithChildren
  AuthMilestonesRouteRoute: typeof AuthMilestonesRouteRouteWithChildren
  AuthOverridesRouteRoute: typeof AuthOverridesRouteRouteWithChildren
  AuthPartnerRouteRoute: typeof AuthPartnerRouteRouteWithChildren
  AuthQaToolsRouteRoute: typeof AuthQaToolsRouteRouteWithChildren
  AuthUserLookupRouteRoute: typeof AuthUserLookupRouteRouteWithChildren
  AuthUnauthorizedRoute: typeof AuthUnauthorizedRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuditRouteRoute: AuthAuditRouteRouteWithChildren,
  AuthBtcToolsRouteRoute: AuthBtcToolsRouteRouteWithChildren,
  AuthEsniRouteRoute: AuthEsniRouteRouteWithChildren,
  AuthIpOverrideRouteRoute: AuthIpOverrideRouteRouteWithChildren,
  AuthLoggerRouteRoute: AuthLoggerRouteRouteWithChildren,
  AuthMediaValidationRouteRoute: AuthMediaValidationRouteRouteWithChildren,
  AuthMilestonesRouteRoute: AuthMilestonesRouteRouteWithChildren,
  AuthOverridesRouteRoute: AuthOverridesRouteRouteWithChildren,
  AuthPartnerRouteRoute: AuthPartnerRouteRouteWithChildren,
  AuthQaToolsRouteRoute: AuthQaToolsRouteRouteWithChildren,
  AuthUserLookupRouteRoute: AuthUserLookupRouteRouteWithChildren,
  AuthUnauthorizedRoute: AuthUnauthorizedRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  SandboxRoute: SandboxRoute,
  ImplicitCallbackRoute: ImplicitCallbackRoute,
  SecureSplatRoute: SecureSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
